import { PurchaseHistoryPartialStoreState, PURCHASE_HISTORY_STATE_KEY } from './purchase-history.reducer';


export const getPurchaseHistory = (state: PurchaseHistoryPartialStoreState) => state[PURCHASE_HISTORY_STATE_KEY].tickets;

export const getPurchaseHistoryLoading  = ( state: PurchaseHistoryPartialStoreState ) => state[PURCHASE_HISTORY_STATE_KEY].loading;

export const getStartDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].startDate;
export const getEndDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].endDate;
export const getMinStartDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].minStartDate;
export const getMinEndDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].minEndDate;
export const getMaxStartDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].maxStartDate;
export const getMaxEndDate = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].maxEndDate;
export const getDateDiff = ( state: PurchaseHistoryPartialStoreState ) => state[ PURCHASE_HISTORY_STATE_KEY ].diff;
